// import { cordova } from "@ionic-native/core";
import firebase from "firebase";
import "firebase/auth";
import { formatError } from ".";
// import { Facebook, FacebookLoginResponse } from "@ionic-native/facebook";
import { COLLECTIONS, updateDoc } from "./firestore";
import { isPlatform } from "@ionic/react";
// import { resolve } from "node:path";

export declare interface AuthCallBackParams {
	uid: string;
	displayName: string;
	email: string;
	phoneNumber: string;
	photoURL: string;
	gender: string;
	date_of_birth: string;
	token: string;
	defaultAddressRef: any;
	defaultVehicleRef: any;
	isAnonymous: Boolean;
	providerId: string;
}
declare let window: any;

export async function listenAuthStateChange(callBack?: Function) {
	const auth = window.cordova ? window.cordova.plugins.firebase.auth : firebase.auth();
	auth.onAuthStateChanged((userInfo: any) => {
		callBackForAuthStateChange(userInfo, callBack);
	});
}

export async function callBackForAuthStateChange(user: any, callBack?: Function) {
	if (user) {
		const { uid, displayName, email, phoneNumber, photoURL, isAnonymous } = user;
		if (window.cordova) {
			const { providerId = "" } = user;
			// alert("Returning User = " + providerId);
			let token = await getIdToken();
			if (callBack) {
				callBack({
					uid,
					displayName,
					email,
					phoneNumber,
					photoURL,
					token,
					providerId,
				});
			}
			return;
		}
		return user.getIdToken().then(function (idToken: any) {
			if (user.providerData.length) {
				var { providerId = "" } = user.providerData[0];
			}
			if (callBack) {
				callBack({
					uid,
					displayName,
					email,
					phoneNumber,
					photoURL,
					token: idToken,
					isAnonymous,
					providerId,
				});
			}
		});
	} else {
		if (callBack) {
			callBack({
				token: null,
			});
		}
	}
}

export async function reCapatchaVerifier() {
	const appVerifier = new firebase.auth.RecaptchaVerifier("recaptcha-container", {
		size: "invisible",
	});
	return appVerifier;
}

export async function signInWithPhoneNumber(mobileNumber: string) {
	let appVerifier: any;
	if (!window.reCapatchaVerifier) {
		window.reCapatchaVerifier = await reCapatchaVerifier();
	}
	appVerifier = window.reCapatchaVerifier;

	const auth = window.cordova ? window.cordova.plugins.firebase.auth : firebase.auth;
	var isSafari = false;
	var ua = navigator.userAgent.toLowerCase();
	if (ua.indexOf("safari") != -1) {
		if (ua.indexOf("chrome") > -1) {
			isSafari = false;
		} else {
			isSafari = true;
		}
	}

	const provider =
		isPlatform("ios") && !isSafari
			? window.cordova.plugins.firebase.auth
			: new firebase.auth.PhoneAuthProvider();

	const returnValue = new Promise(async (resolve, reject) => {
		return await provider
			.verifyPhoneNumber(
				mobileNumber,
				isPlatform("ios") && !isSafari ? 10000 : appVerifier
			)
			.then(function (verificationId: any) {
				resolve({ verificationId });
			})
			.catch(function (err: any) {
				reject(err.code);
			});
	});
	return returnValue;
}

const getAuth = () => {
	return window.cordova
		? window.cordova.plugins.firebase.auth
		: (firebase as any).auth().currentUser;
};

export const getIdToken = async (forceRefresh = false) => {
	const auth = window.cordova
		? window.cordova.plugins.firebase.auth
		: (firebase as any).auth().currentUser;

	if (!!auth) {
		return await auth
			.getIdToken(forceRefresh)
			.then(function (idToken: any) {
				return idToken;
			})
			.catch(function (error: any) {
				console.error("Firebase - 140", error);
				return error.code;
				formatError(error.code);
			});
	}
};

export async function enterOTP(confirmationResult: any, otp: string) {
	if (!window.cordova) {
		const credential = firebase.auth.PhoneAuthProvider.credential(
			confirmationResult.verificationId,
			otp
		);
		return await firebase
			.auth()
			.signInWithCredential(credential)
			.catch((error) => {
				console.error(error, "CredentialError");
				return error.code;
			});
	} else {
		const credential = window.cordova.plugins.firebase.auth
			.signInWithVerificationId(confirmationResult.verificationId, otp)
			.then(() => {
				return getIdToken();
			})
			.catch((error: any) => {
				return "auth/invalid-verification-code";
			});
		return credential;
	}
}

export async function confirmOtp(confirmationResult: any, otp: string) {
	return confirmationResult
		.confirm(otp)
		.then((result: any) => {
			return getIdToken();
		})
		.catch((error: any) => {
			return error.code;
			formatError(error.code);
		});
}

export async function verifyIdToken(token: string) {
	if (!token) {
		throw new Error("Need token to verify");
	}
	// return firebase.
}

export async function signOut() {
	const auth = window.cordova ? window.cordova.plugins.firebase.auth : firebase.auth();
	return auth
		.signOut()
		.then(() => {
			return { token: null };
		})
		.catch((error: any) => {
			console.error(error);
		});
}

export async function signInWithGoogle() {
	if (window.cordova) {
		// alert("Starting Google Sign In");
		return new Promise((resolve, reject) => {
			window.plugins.googleplus.login(
				{
					scope: "https://www.googleapis.com/auth/userinfo.profile",
					webClientId:
						"712992810397-17c95f2j334e99igrk3l21sn9b9ohq6t.apps.googleusercontent.com",
				},
				function (res: any) {
					window.cordova.plugins.firebase.auth
						.signInWithGoogle(res.idToken, res.accessToken)
						.then(function () {
							// alert("Firebase logged in with Google");
							getIdToken();
							resolve(getIdToken());
						});
				},
				function (err: any) {
					console.error("login failed", err);
				}
			);
		});
	} else {
		const provider = new firebase.auth.GoogleAuthProvider();
		provider.addScope("https://www.googleapis.com/auth/userinfo.profile");
		return socialLoginAuth(provider);
	}
}

// export async function signInWithFaceBook() {
// 	if (window.cordova) {
// 		return Facebook.login(["public_profile", "email"])
// 			.then(async (res: FacebookLoginResponse) => {
// 				const token = await Facebook.getAccessToken();
// 				window.cordova.plugins.firebase.auth.signInWithFacebook(token).then(function () {
// 					// alert("Firebase logged in with FaceBook");
// 					getIdToken();
// 				});

// 				// alert(token);
// 			})
// 			.catch((e: any) => console.error("Error logging into Facebook", e));
// 	}
// 	const provider = new firebase.auth.FacebookAuthProvider();
// 	// provider.addScope("id,name,email,location,birthday");
// 	return socialLoginAuth(provider);
// }

async function socialLoginAuth(provider: any) {
	return await firebase
		.auth()
		.signInWithPopup(provider)
		.then((result: any) => {
			/** @type {firebase.auth.OAuthCredential} */
			// var credential = result.credential;
			// This gives you a Google Access Token. You can use it to access the Google API.
			// var token = credential.accessToken;
			// The signed-in user info.
			// var user = result.user;
			// ...
			return getIdToken();
		})
		.catch((error: any) => {
			console.error(error, "Fjsdk");
			return error.code;
		});
}

export async function signInAnonymously() {
	const auth = window.cordova ? window.cordova.plugins.firebase.auth : firebase.auth();
	const result = auth.signInAnonymously();
	return await result
		.then((result: any) => {
			return { ...getIdToken(), isAnonymous: true };
		})
		.catch(function (error: any) {
			// Handle Errors here.
			var errorCode = error.code;
			var errorMessage = error.message;
			return { isError: true, ...error.code };
			formatError(error.code);
			console.error(error);
		});
}

export async function AnonymousToGoogleAccount() {
	const anonUser = (firebase as any).auth().currentUser;

	const provider = new firebase.auth.GoogleAuthProvider();

	provider.addScope("https://www.googleapis.com/auth/userinfo.profile");
	return linkWithPopup(anonUser, provider);
}

// export async function AnonymousToFacebookAccount() {
// 	const anonUser = (firebase as any).auth().currentUser;

// 	const provider = new firebase.auth.FacebookAuthProvider();

// 	return linkWithPopup(anonUser, provider);
// }

export async function AnonymousToMobileAccount(confirmationResult: any, otp: any) {
	const anonUser = (firebase as any).auth().currentUser;

	const provider = firebase.auth.PhoneAuthProvider.credential;
	const credential = await provider(confirmationResult.verificationId, otp);

	if (!window.cordova) {
		return await anonUser
			.linkWithCredential(credential)
			.then(async (userInfo: any) => {
				var user = userInfo.user;
				// console.log("USER ====== ", user);
				if (user) {
					const {
						uid,
						email = "",
						photoURL = "",
						displayName = "",
						phoneNumber = "",
					} = user;
					const { providerId = "" } = user.providerData[0];
					updateDoc(
						uid,
						{
							email: email,
							profileImagePath: photoURL,
							isAnonymous: false,
							name: displayName,
							primaryPhoneNumber: phoneNumber,
							providerId: providerId,
						},
						COLLECTIONS.USERS
					);
					const idToken = await getIdToken();
					return { token: idToken, email, photoURL, phoneNumber, displayName };
				}
			})
			.catch((error: any) => {
				return error.code;
				// formatError(error.code);
			});
	}
}

export async function linkWithPopup(user: any, provider: any) {
	return user
		.linkWithPopup(provider)
		.then(async (usercred: any) => {
			var user = usercred.user;
			if (user) {
				const { uid } = user;
				if (user.providerData) {
					var {
						email = "",
						photoURL = "",
						displayName = "",
						phoneNumber = "",
						providerId = "",
					} = user.providerData[0];
				}
				updateDoc(
					uid,
					{
						email: email || "",
						profileImagePath: photoURL || "",
						isAnonymous: false,
						name: displayName || "",
						primaryPhoneNumber: phoneNumber || "",
						providerId: providerId || "",
					},
					COLLECTIONS.USERS
				);
				const idToken = await getIdToken();
				return { token: idToken, email, photoURL, displayName };
			}
		})
		.catch((error: any) => {
			console.error("Error upgrading anonymous account", error);
			return error;
		});
}

export async function getDeviceToken() {
	if (window.cordova) {
		window.cordova.plugins.firebase.messaging
			.getToken()
			.then((token: any) => {
				console.error("Device Token Generated");
			})
			.catch((error: any) => {
				console.error("Error generating device token", error);
				// alert(error);
				console.error("Auth - 393", error);
			});
	}
}

export async function signInWithApple() {
	if (window.cordova) {
		window.cordova.plugins.SignInWithApple.signin(
			{ requestedScopes: [0, 1] },
			(succ: any) => {
				window.cordova.plugins.firebase.auth
					.signInWithApple(succ.identityToken, "nonce")
					.then(() => {
						return getIdToken();
					});
			},
			(err: any) => {
				console.error(err, "appleLoginFailed");
			}
		);
	} else {
		var provider = new firebase.auth.OAuthProvider("apple.com");
		provider.addScope("email");
		provider.addScope("name");
		return socialLoginAuth(provider);
	}
}
